import {Routes, Route,BrowserRouter} from 'react-router-dom';

import { Footer } from '../components'
import * as Pages from "../pages";

import { AuthProvider } from './context';

function HomePage() { 
  return (
      <AuthProvider>
        <Pages.Hero/>
        <Pages.PersonalInfo/>
        <Pages.EducationalJourney/>
        <Pages.ProfessionalBackground/>
        <Pages.SkillsTechnical/>
        <Pages.FamilyBackground />
        <Pages.SpiritualJourney/>
        <Footer/>
      </AuthProvider>
  );
}

function App() {

    return (
      <BrowserRouter>
        <AuthProvider>
          <Routes>

            <Route index  element={<HomePage/>} />
            {/* <Route path="/soon" element={<pages.ComingSoon/>} />
            <Route path='*' element={<pages.PageNotFound />} /> */}

          </Routes>
        </AuthProvider>
      </BrowserRouter>
    )
}

export default App

